export const getStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export const setlocalStorage = (key, value) => {
  return localStorage.setItem(key, value);
};

export const getTag = (status, t) => {
  switch (status) {
    case "success":
      return {
        // icon: <CheckCircleOutlined />,
        name: `${t("txt_succeedV2")}`,
        color: "#28a745",
      };
    case "process":
      return {
        // icon: <SyncOutlined spin />,
        name: `${t("txt_process")}`,
        color: "#ffc107",
      };
    case "failed":
      return {
        // icon: <ExclamationCircleOutlined />,
        name: `${t("txt_isnot_success")}`,
        color: "#dc3545",
      };
    case "withdraw_failed":
      return { name: `${t("txt_isnot_success")}`, color: "magenta" };
    case "withdraw_cancel":
      return { name: `${t("txt_cancel")}`, color: "#dc3545" };
    case "withdraw_success":
      return { name: `${t("txt_succeedV2")}`, color: "#28a745" };
    case "withdraw_waiting":
      return { name: `${t("txt_wait_process")}`, color: "gold" };
    default:
      return { name: "-", color: "" };
  }
};

export const getTagLotto = (status, t) => {
  switch (status) {
    case "success":
      return {
        name: `${t("txt_the_prize_has_been_issued")}`,
        color: "#0d6efd",
      };
    case "cancel":
      return { name: `${t("txt_cancel")}`, color: "#ff4d3b" };
    case "pending":
      return {
        name: `${t("txt_waiting_for_the_prize_drawn")}`,
        color: "#ffc107",
      };
    case "won":
      return {
        name: `${t("txt_won_a_prize")}`,
        color: "#28a745",
      };
    case "lost":
      return {
        name: `${t("txt_didn_win_the_prize")}`,
        color: "#dc3545",
      };
    case "active":
      return {
        name: `${t("txt_waiting_for_the_prize_drawn")}`,
        color: "#ffc107",
      };
    case "settled":
      return {
        name: `${t("txt_the_prize_has_been_issued")}`,
        color: "#ffc107",
      };
    case "cancelled":
      return { name: `${t("txt_cancel")}`, color: "#ff4d3b" };
    default:
      return { name: "-", color: "" };
  }
};

export const getThai10MinSeed = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const thailandOffset = 7 * 60;
  const thTime = new Date(utc + 60000 * thailandOffset);

  const yyyy = thTime.getFullYear();
  const mm = String(thTime.getMonth() + 1).padStart(2, "0");
  const dd = String(thTime.getDate()).padStart(2, "0");
  const hh = String(thTime.getHours()).padStart(2, "0");
  const min10 = Math.floor(thTime.getMinutes() / 10) * 10;
  const m10 = String(min10).padStart(2, "0");

  return {
    seed: `thai-10min-${yyyy}-${mm}-${dd}-${hh}:${m10}`,
    hour: thTime.getHours(),
  };
};

export const getThai2MinSeed = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const thailandOffset = 7 * 60;
  const thTime = new Date(utc + 60000 * thailandOffset);

  const yyyy = thTime.getFullYear();
  const mm = String(thTime.getMonth() + 1).padStart(2, "0");
  const dd = String(thTime.getDate()).padStart(2, "0");
  const hh = String(thTime.getHours()).padStart(2, "0");
  const min2 = Math.floor(thTime.getMinutes() / 2) * 2;
  const m2 = String(min2).padStart(2, "0");

  return {
    seed: `thai-2min-${yyyy}-${mm}-${dd}-${hh}:${m2}`,
    hour: thTime.getHours(),
  };
};
